var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPasswordHidden(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.004,
    height: 10.502,
    viewBox: "0 0 24.004 10.502",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Password_Hidden",
    "data-name": "Password Hidden",
    d: "M322.69,185.082l-.96.35.79,1.37a1,1,0,0,1-.36,1.37,1.013,1.013,0,0,1-1.37-.37l-.97-1.68-1.66.61c-.3.11-.6.21-.9.29l.79,2.16a1,1,0,0,1-.6,1.28,1.016,1.016,0,0,1-.34.06,1,1,0,0,1-.94-.65l-.86-2.37a16.192,16.192,0,0,1-2.31.28v2.92a1,1,0,0,1-2,0v-2.92a16.229,16.229,0,0,1-2.3-.28l-.86,2.37a1.012,1.012,0,0,1-.94.65,1.074,1.074,0,0,1-.35-.06.993.993,0,0,1-.59-1.28l.78-2.16c-.3-.08-.6-.18-.9-.29l-1.66-.61-.97,1.68a1,1,0,0,1-.87.5.991.991,0,0,1-.86-1.5l.79-1.37-.95-.35a2,2,0,1,1,1.37-3.76l1.61.59,1.91.7,1,.36c.31.11.63.21.94.3a14.675,14.675,0,0,0,3.38.53c.31.01.63.01.94,0a14.675,14.675,0,0,0,3.38-.53c.31-.09.63-.19.94-.3l1-.37,1.91-.69,1.62-.59a2,2,0,0,1,1.37,3.76",
    transform: "translate(-299.998 -181.2)",
    fill: "#B6B7BF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPasswordHidden);
export default __webpack_public_path__ + "static/media/PasswordHidden.b584d304c92cb9c5e82885eabde7183c.svg";
export { ForwardRef as ReactComponent };